import { Component, HostListener, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { AuthService } from 'src/app/services/api/auth/auth.service';
import { SorteosService } from 'src/app/services/api/sorteos/sorteos.service';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { ChangeDetectorRef } from '@angular/core';


@Component({
  selector: 'app-sorteos',
  templateUrl: './sorteos.component.html',
  styleUrls: ['./sorteos.component.scss']
})
export class SorteosComponent implements OnInit {
  sorteo: any;
  errorPuntos: string = '';
  loading: boolean = true;
  showModal: boolean = false;
  aceptarTerminos: boolean = false;
  isLoggedIn: boolean = false;
  expirationDate: string = '';
  breakpoint = 768;
  isResponsive: boolean = false;
  typeValue: string = '';
  limitExceeded: boolean = false;


  itemCode: string = '';

  singularValue: string = '';
  pluralValue: string = '';

  conversorSorteosForm: FormGroup;

  inputAmount: number = 0;
  outputAmount: number = 0;
  chances: number = 0;
  puntos: number = 0;

  errorMessage: string = '';

  conversionInProgress = false;

  constructor(
    public authService: AuthService,
    private formbuilder: FormBuilder,
    private sorteosService: SorteosService,
    private route: ActivatedRoute,
    private router: Router
  ) {
    this.conversorSorteosForm = this.formbuilder.group({
      inputValue: new FormControl('', []),
      aceptarTerminos: new FormControl(false),
    });

    this.checkLoginStatus();
  }

  steps = [
    {
      number: 1,
      text: '',
      span: 'Presentando tu DNI o abonando con la App'
    },
    {
      number: 2,
      text: '',
      span: ''
    },
    {
      number: 3,
      text: '',
      span: 'Y te mostraremos los puntos que estás canjeando'
    }
  ]

  ngOnInit(): void {
    this.setImageBasedOnWidth(window.innerWidth);
    this.route.params.subscribe((params: Params) => {
      const code = params['code'];
      if (code) {
        this.sorteosService.getByName(code).subscribe(
          (sorteo: any) => {
            this.sorteo = sorteo;
            this.itemCode = sorteo.code;
            this.expirationDate = new Date(sorteo.expirationDate).toLocaleDateString();

            
            //change title with code sorteo_quevedo
            if (this.sorteo.code === 'sorteo_quevedo') {
              this.sorteo.longDescription = 'Shell Box te lleva al Buenas Noches LatamTour.;Canjeá tus puntos Shell Box por entradas para ir a verlo.';
            }

            const description9Parts = sorteo.description9.split('|');
            if (description9Parts.length === 2) {
              const pluralParts = description9Parts[1].split(',');
              if (pluralParts.length === 2) {
                const singular = pluralParts[0];
                const plural = pluralParts[1];
                this.typeValue = description9Parts[0];
                this.singularValue = singular;
                this.pluralValue = plural;
              }
            } else {
              this.typeValue = description9Parts[0];
            }
            this.steps[0].text = `Comprá con Shell Box y con cada compra acumulá puntos para canjearlos por ${this.typeValue  !== 'Sorteo' ? this.pluralValue : 'chances' }`;
            this.steps[1].text = `${sorteo.price} ${sorteo.price === 1 ? 'punto' : 'puntos'} x 1 ${this.typeValue  !== 'Sorteo' ? this.singularValue : 'chance' }`;
            this.steps[1].span = `Una ${this.typeValue  !== 'Sorteo' ? this.singularValue : 'chance' } vale ${sorteo.price} ${sorteo.price === 1 ? 'punto' : 'puntos'}`;
            this.steps[2].text = `Elegí cuántas ${this.typeValue  !== 'Sorteo' ? this.pluralValue : 'chances' } querés`;
            this.loading = false;
          },
          (error: any) => {
            console.error(error);
            this.loading = false;
          }
        );
      } else {
        this.loading = false;
      }
    });
  }
  
  getBackgroundImageStyleDesktop(): any {
    if (this.isExpired() && this.sorteo?.description9 === 'Sorteo' && this.sorteo?.description7 && this.itemCode === 'sorteo_fire_league') {
      return {
        'background-image': 'url(../../../assets/images/ShellBoxFireLeagueDesktopFinalizado.png)'
      };
    } else if (!this.isExpired() && this.itemCode === 'sorteo_fire_league') {
      return {
        'background-image': 'url(../../../assets/images/ShellBoxFireLeagueDesktop.png)'
      };
    } else if (this.sorteo?.largeImageURL) {
      return {
        'background-image': `url(${this.sorteo?.largeImageURL})`,
        'justify-content': this.sorteo?.description12 === 'A1' || this.sorteo?.description12 === 'A2' ? 'flex-end' : 'flex-start'
      };
    }
  }  

  getBackgroundImageUrl(): string {
    if (this.isExpired() && this.sorteo?.description9 === 'Item|código,códigos' && this.itemCode === 'sorteo_ags_2') {
      return '../../../assets/images/soldOutDesktop.jpg';
    } else if (!this.isExpired() && this.itemCode === 'sorteo_fire_league') {
      return '../../../assets/images/ShellBoxFireLeagueDesktop.png';
    } else if (this.sorteo?.description9 === 'Item|código,códigos' && this.itemCode === 'sorteo_ags_2') {
      return '../../../assets/images/soldOutDesktop.jpg';
    } else if (this.sorteo?.description9 === 'Item|entrada,entradas' && this.itemCode === 'sorteo_trap_domingo1') {
      return '../../../assets/images/banner/bannerDomingo.png';
    } else if (this.sorteo?.description9 === 'Item|entrada,entradas' && this.itemCode === 'sorteo_trap_sabado') {
      return '../../../assets/images/banner/bannerSabado.png';
    } else if (this.sorteo?.largeImageURL) {
      return this.sorteo?.largeImageURL;
    }
    return '';
  }
  
  getJustifyContent(): string {
    return (this.sorteo?.description12 === 'A1' || this.sorteo?.description12 === 'A2') ? 'flex-end' : 'flex-start';
  }
  
  getImageSrc(): string {
    if (!this.isExpired() && this.itemCode === 'sorteo_fire_league') {
      return '/assets/images/ShellBoxFireLeagueMobile.png';
    } else if (this.isExpired() && this.sorteo?.description9 === 'Item|código,códigos' && this.itemCode === 'sorteo_ags_2') {
      return '/assets/images/soldOutMobile.jpg';
    } else if (this.sorteo?.description9 === 'Item|entrada,entradas' && this.itemCode === 'sorteo_trap_domingo1') {
      return '/assets/images/banner/bannerDomingoMobile.png';
    } else if (this.sorteo?.description9 === 'Item|entrada,entradas' && this.itemCode === 'sorteo_trap_sabado') {
      return '/assets/images/banner/bannerSabadoMobile.png';
    } else {
      return this.sorteo?.description9 === 'Sorteo' ? this.sorteo?.mediumImageURL : this.sorteo?.smallImageURL;
    }
  } 

  isExpired() {
    if (!this.sorteo?.expirationDate) return true;
    const expirationDate = new Date(parseInt(this.sorteo.expirationDate));
    return expirationDate <= new Date();
  }

  getImageUrl(description: string) {
    switch (description) {
      case 'Gaming':
        return 'url(../../../assets/draw/Shell-Box-Template-Gaming-01.png)';
      case 'Music':
        return 'url(../../../assets/draw/Shell-Box-Template-Musica-01.png)';
      case 'ACTC':
        return 'url(../../../assets/draw/Shell-Box-Template-ACTC.png)';
      case 'Viajes':
        return 'url(../../../assets/draw/Shell-Box-Template-Viajes-01.png)';
      case 'Generico':
        return 'url(../../../assets/draw/Shell-Box-Template-Generico-01.png)';
      default:
        return 'url(../../../assets/draw/Shell-Box-Template-VPower-01.png)';
    }
  }

  getImageUrlMobile(description: string) {
    switch (description) {
      case 'Gaming':
        return 'url(../../../assets/draw/Shell-Box-Template-Gaming-mobile.png)';
      case 'Music':
        return 'url(../../../assets/draw/Shell-Box-Template-Musica-mobile.png)';
      case 'ACTC':
        return 'url(../../../assets/draw/Shell-Box-Template-ACTC-mobile.png)';
      case 'Viajes':
        return 'url(../../../assets/draw/Shell-Box-Template-Viajes-mobile.png)';
      case 'Generico':
        return 'url(../../../assets/draw/Shell-Box-Template-Generico-mobile.png)';
      default:
        return 'url(../../../assets/draw/Shell-Box-Template-VPower-mobile.png)';
    }
  }

  async checkLoginStatus(): Promise<void> {
    try {
      this.isLoggedIn = await this.authService.IsLoggedIn();
      this.updateValidators();
    } catch (error) {
      console.error(error);
    }
  }

  updateValidators(): void {
    const aceptarTerminosControl = this.conversorSorteosForm.get('aceptarTerminos');

    if (this.isLoggedIn) {
      aceptarTerminosControl?.setValidators([Validators.requiredTrue]);
    } else {
      aceptarTerminosControl?.clearValidators();
    }
    aceptarTerminosControl?.updateValueAndValidity();
  }

  incrementValue() {
    if (this.limitExceeded) {
      return;
    }
    const currentValue = parseInt(this.conversorSorteosForm.get('inputValue')?.value || '0', 10);
    this.conversorSorteosForm.patchValue({
      inputValue: (currentValue + 1).toString()
    });
    const inputAmount = Math.round(currentValue + 1);
    this.chances = inputAmount;
    this.handleInputChange({ target: { value: currentValue + 1 } });
  }

  decrementValue() {
    const currentValue = parseInt(this.conversorSorteosForm.get('inputValue')?.value || '0', 10);
    if (currentValue === 0) {
      this.resetValues();
      this.conversorSorteosForm.get('inputValue')?.setValue('');
      return;
    }

    if (currentValue > 0) {
      this.conversorSorteosForm.patchValue({
        inputValue: (currentValue - 1).toString()
      });
      const inputAmount = Math.round(currentValue - 1);
      this.chances = inputAmount;
      this.handleInputChange({ target: { value: currentValue - 1 } });
    }
  }
  

  handleInputChange(event: any): void {

    let inputValue: string = event.target.value;

    inputValue = inputValue.replace(/\D/g, '');
    inputValue = inputValue.slice(0, 4);
    this.conversorSorteosForm.get('inputValue')?.setValue(inputValue);

    const price = this.sorteo?.price;


    if( inputValue === '0' || inputValue === '' ) {
      this.resetValues();
      this.conversorSorteosForm.get('inputValue')?.setErrors({ 'invalid': true });
      return;
    }

    if (parseFloat(inputValue) <= 0) {
      this.resetValues();
      this.conversorSorteosForm.get('inputValue')?.setValue('');
    } else {
      const parsedInputValue = parseInt(inputValue);
      if (!isNaN(parsedInputValue)) {
        const inputAmount = Math.round(parsedInputValue);
        const output = Math.round(parsedInputValue * price);
        if (!isNaN(output)) {
          this.outputAmount = output;
        }
        this.chances = inputAmount;
        this.puntos = output;
      } else {
        this.resetValues();
      }
    }
  }

  resetValues(): void {
    this.chances = 0;
    this.puntos = 0;
  }

  getItemValue(item: any, property: string, index: number): string {
    if (item && typeof item[property] === 'string') {
      const parts = item[property].split(';');
      return parts[index] || '';
    }
    return '';
  }

  async handleConversion(): Promise<void> {

    if (await this.authService.IsLoggedIn()) {

      if (this.chances <= 0) {
        return;
      } else if (this.chances > this.sorteo?.maxQuotaAvailable) {
        this.limitExceeded = true;
        this.errorPuntos = 'Superaste el límite de entradas permitidas';
        return;
      }

      this.conversionInProgress = true;

      this.sorteosService.convert({
        itemCode: this.sorteo?.code,
        quantity: this.chances.toString()
      })
        .subscribe(
          (response: any) => {

            const totalPrice = this.sorteo?.price * this.chances;
            const userData = localStorage.getItem('user');
            if (userData) {
              const user = JSON.parse(userData);
              const availableBalance = user.context.activities[0].personStatus.accountBalance;

              const newBalance = availableBalance - totalPrice;
              user.context.activities[0].personStatus.accountBalance = newBalance;
              localStorage.setItem('user', JSON.stringify(user));

            }
            
            this.showModal = true;
            this.conversionInProgress = false;
          

            this.authService.getPerson().subscribe(data => {
              this.authService.refreshUser(data);

            });
            this.inputAmount = this.chances;

            this.limitExceeded = false;
          },
          (error: any) => {
            const currentChances = this.chances;
            const totalPrice = this.sorteo?.price * currentChances;         
            this.conversorSorteosForm.get('inputValue')?.setValue('');
            this.chances = 0;
            const userData = localStorage.getItem('user');
            if (userData) {
              const user = JSON.parse(userData);
              const availableBalance = user.context.activities[0].personStatus.accountBalance;
              if (totalPrice > availableBalance) {
                this.errorPuntos = 'No tenes puntos disponibles para realizar la operación.';
                return;
              }
            }

            this.errorPuntos = 'Superaste el límite de entradas permitidas por evento.';
            this.limitExceeded = true;
            console.error('Error en la conversión de chances a puntos:', error);
          }
        );

    } else {
      document.getElementsByClassName('modal-login')[0].classList.add('visible');
      document.getElementsByTagName('body')[0].classList.add('noScroll');
    }
  }

  handleModal(): void {
    window.location.reload();
  }

    @HostListener('window:resize', ['$event'])
    onResize(event: any) {
      this.setImageBasedOnWidth(event.target.innerWidth);
    }
  
    private setImageBasedOnWidth(width: number) {
      if (width >= this.breakpoint) return this.isResponsive = false;
      return this.isResponsive = true;
    }

}
